import React, { useState } from 'react';

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'prsilks' && password === 'ramesh@123') {
      onLogin(true);
    } else {
      alert("Invalid username or password");
    }
  };

  return (
    <div className="p-8 mt-36 py-20 mb-10 max-w-sm mx-auto bg-white rounded shadow">
      <h2 className="text-xl font-bold text-center mb-4">Admin Login</h2>
      <form  onSubmit={handleLogin}>
        <input
          className="w-full p-2 mb-3 border rounded"
          type="text"
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="w-full p-2 mb-3 border rounded"
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className='flex justify-center'>
          <button className="w-24 border border-secondary bg-secondary text-primary font-bold py-2 rounded" type="submit">Login</button>
        </div>
        
      </form>
    </div>
  );
};

export default AdminLogin;
